(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-boxed-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('boxed-review-content')) {
    customElements.define('boxed-review-content', class extends HTMLElement {
      connectedCallback() {
        const removeRatingLinks = () => {
          this.querySelectorAll('a.jm-average-rating-display[href], .jdgm-rev-widg__summary a[href]').forEach((link) => {
            const hostname = new URL(link.href).hostname;
            if (hostname !== 'judge.me' && !hostname.endsWith('.judge.me')) return;
            link.removeAttribute('href');
            link.removeAttribute('target');
            link.removeAttribute('role');
            link.removeAttribute('tabindex');
            link.removeAttribute('aria-label');
          });
        };
        this.ratingLinkObserver = new MutationObserver(removeRatingLinks);
        this.ratingLinkObserver.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
        removeRatingLinks();
      }

      disconnectedCallback() {
        this.ratingLinkObserver.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
